import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Input,
  InputGroup, InputGroupAddon, InputGroupText, CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import Association from '../../consultation/Association';
import EncaissementScanModal from '../../encaissement_list/EncaissementScanModal';
import { checkEncaissementUniqueness } from '../../../flux/actions/encaissementActions';
import { addEncaissementLine, clearEncaissementLines } from '../../../flux/actions/encaissementlineActions';
import { getBanqueVersements, clearBanqueVersements } from '../../../flux/actions/banqueversementActions';
import { getBanks, clearBanks } from '../../../flux/actions/bankActions';
import { getFtpCheck } from '../../../flux/actions/encaissementActions';
import { IVEncaissementLineReduxProps, IVEncaissementComponent, ITarget, IEncaissementLine, IEncaissement } from '../../../types/interfaces';
import { constants } from '../../../types/constants';
import { E_ERROR } from '../../../types/errors';
import { getEncModeRegl } from '../../../services/misc';
import moment from "moment";
import Loading from '../../Loading';

import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { useAlert } from "react-alert";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faCheck, faFileImage, faHandRock, faSearchDollar, faPen, faTimes, faSpinner, faExternalLinkAlt, faCheckCircle, faSearch, faArrowLeft, faEye, faMoneyCheck, faGripLines, faUndo, faRedo, faCommentMedical, faHourglassHalf, faCalendarTimes } from '@fortawesome/free-solid-svg-icons'

import axios from 'axios';

import { useDropzone } from 'react-dropzone';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import DatePicker from "reactstrap-date-picker";
import { b64toBlob } from '../../pdf/PDFLink';
import NumberFormat from 'react-number-format';

const VAddEncaissement = ({
  project,
  encaissementline,
  addEncaissementLine,
  getBanks,
  clearBanks,
  banqueversement,
  getBanqueVersements,
  clearBanqueVersements,
  bank,
  client,
  consulationClients,
  consultationIsAssociation,
  consultationAssociations,
  consultationContrat,
  isConsultation,
  // clients,
  encaissement,
  auth
}: IVEncaissementComponent) => {

  const { table_clients } = client;
  const { encaissementlines } = encaissementline;
  const { remainingEncaissements, loading: loadingE } = encaissement;
  const { banqueversements, loading: loadingBv } = banqueversement;
  const { banks, loading: loadingBank } = bank;
  
  // const modereglementOptions0 = [{value: "CHEQUE", label: "Chèque"}, {value: "VERSEMENT", label: "Versement"}, {value: "VIREMENT", label: "Virement"}];
  const modereglementOptions = [constants.MODE_REGL_CHEQUE, constants.MODE_REGL_VERSEMENT, constants.MODE_REGL_VIREMENT].map(e => ({value: e, label: getEncModeRegl(e)}));
  const typeecheanceOptions = [{value: "Acompte réservation", label: "Acompte réservation"}, {value: "Recouvrement", label: "Recouvrement"}, {value: "Reliquat livraison", label: "Reliquat livraison"}];
  const selectBvOptions = banqueversements.map(e => ({value: e, label: `${e.libelle} (${e.num_compte})`}));
  const selectBankOptions = banks.map(e => ({value: e, label: e.fullname}));
  const typeClientOptions = [{value: 1, label: "Client"}, {value: 2, label: "Promoteur"}/*, {value: 3, label: "Salarié Shems Al Madina"}*/];

  const [partFrom, setPartFrom] = useState(0);
  const [bankValue, setBankValue] = useState<any>('');
  const [bvValue, setBvValue] = useState<any>('');
  // const [bvDisabled, setBvDisabled] = useState(false);
  const [auprofitdeValue, setAuprofitdeValue] = useState('');
  const [tireparValue, setTireparValue] = useState<any>('');
  const [refencaissementValue, setRefencaissementValue] = useState('');
  const [montantValue, setMontantValue] = useState(0);
  const [quotePartValue, setQuotePartValue] = useState(0);
  const [quotePartMaxValue, setQuotePartMaxValue] = useState(0);
  const [quotePartColor, setQuotePartColor] = useState('');
  const [modeReglementValue, setModeReglementValue] = useState<any>(/*modereglementOptions[0]*/'');
  const [nepasverserValue, setNepasverserValue] = useState(false);
  const [commentAnpv, setCommentAnpv] = useState('');
  const [typeEcheanceValue, setTypeEcheanceValue] = useState(isConsultation ? typeecheanceOptions[1] : typeecheanceOptions[0]);
  const [dateCValue, setDateCValue] = useState('');
  const [dateEValue, setDateEValue] = useState('');
  const [commentDateEnc, setCommentDateEnc] = useState('');
  const [dateCCanBeChanged, setDateCCanBeChanged] = useState(true);
  const [dateECanBeChanged, setDateECanBeChanged] = useState(true);
  const [selectedTypeClient, setSelectedTypeClient] = useState<any>('');
  const [observationValue, setObservationValue] = useState('');
  const [montantFlag, setMontantFlag] = useState(false);
  const [quotePartFlag, setQuotePartFlag] = useState(false);
  const montantRef = useRef<HTMLInputElement>(document.createElement("input"));
  const quotePartRef = useRef<HTMLInputElement>(document.createElement("input"));
  const [montantCanBeChanged, setMontantCanBeChanged] = useState(true);
  const [quotePartCanBeChanged, setQuotePartCanBeChanged] = useState(true);
  const [lineCountValue, setLineCount] = useState(0);
  const [addedFlag, setAddedFlag] = useState(false);
  const [isAddingLine, setIsAddingLine] = useState(false);
  const [showComment, setShowComment] = useState(false)
  const [anpvModal, setAnpvModal] = useState(false)
  const [dateEncModal, setDateEncModal] = useState(false)
  
  //
  const [partSearchVisibility, setPartSearchVisibility] = useState(false);
  const [projetSValue, setProjetS] = useState('');
  const [refReglementSValue, setRefReglementS] = useState('');
  const [tireParSValue, setTireParS] = useState('');
  const [auprofitdeSValue, setAuprofitdeS] = useState('');
  const [banqueSValue, setBanqueS] = useState('');
  const [modeReglementSValue, setModeReglementS] = useState('');

  const projetSChangeHandler = (e: ITarget) => setProjetS(e.target.value);
  const refReglementSChangeHandler = (e: ITarget) => setRefReglementS(e.target.value);
  const tireParSSChangeHandler = (e: ITarget) => setTireParS(e.target.value);
  const auprofitdeSSChangeHandler = (e: ITarget) => setAuprofitdeS(e.target.value);
  const banqueSChangeHandler = (e: ITarget) => setBanqueS(e.target.value);
  const modeReglementSChangeHandler = (e: ITarget) => setModeReglementS(e.target.value);
  
  const [disableChoosePart, setDisableChoosePart] = useState(false);
  const [partScanModal, setPartScanModal] = useState(false);
  const [partScanModalData, setPartScanModalData] = useState<any>('');

  const [modalPart, setModalPart] = useState(false);
  const handleTogglePart = () => setModalPart(!modalPart);

  const selectEncaissementHandle = async (e: IEncaissement) => {
    setDisableChoosePart(true);
    setTireparValue({name: e.TIRE_PAR, isNew: true});
    setModeReglementValue(modereglementOptions.find(t => t.value === e.MODE_REGL) || '');
    setNepasverserValue(!!(e.STATUT === constants.STATUT_ENC_A_NE_PAS_VERSER_NR || e.STATUT === constants.STATUT_ENC_A_NE_PAS_VERSER_R))
    setBvValue(e.banque_versement || '')
    // setTypeEcheanceValue(e.TYPE_ECHEANCE);
    setRefencaissementValue(e.REF_REGLEMENT);
    setBankValue((e.IDBANQUE !== undefined && e.IDBANQUE !== null ? selectBankOptions.find(t => t.value?.id === e.IDBANQUE)?.value : selectBankOptions.find(t => t.value?.name === e.BANQUE)?.value) || '');
    setSelectedTypeClient(typeClientOptions.find(t => t.value === Number(e.typeClient || 1)) || '');
    // setAuprofitdeValue(e.PROFIT_DE || "");
    setMontantCanBeChanged(false);
    setQuotePartCanBeChanged(false);
    setMontantValue(e.MONTANT || 0);
    setQuotePartValue(e.contrat_encaissements && e.MONTANT ? Number(e.MONTANT - e.contrat_encaissements.reduce((n, t) => {
      return t.PART ? n + Number(t.PART) : n
    }, 0)) : 0);
    setQuotePartMaxValue(e.contrat_encaissements && e.MONTANT ? Number(e.MONTANT - e.contrat_encaissements.reduce((n, t) => {
      return t.PART ? n + Number(t.PART) : n
    }, 0)) : 0);
    setDateEValue(e.DATE_REGLEMENT.toString());
    setDateCValue(e.DATE_PORTEFEUILLE.toString());
    setObservationValue(e.OBSERVATION || "")
    setModalPart(false);
    setPartFrom(e.id || 0);
    
    let rectoPath: any = null,
        versoPath: any = null,
        rectoIsAbsolutePath = 0,
        versoIsAbsolutePath = 0;
    if(e.recto_name)
      rectoPath = e.recto_name
    else if(e.URL){
      rectoPath = e.URL
      rectoIsAbsolutePath = 1;
    }
    if(e.verso_name)
      versoPath = e.verso_name
    else if(e.URL_VERSO){
      versoPath = e.URL_VERSO
      versoIsAbsolutePath = 1;
    }
    if(rectoPath){
      const rectoFtpCheck = await getFtpCheck(rectoPath, rectoIsAbsolutePath);
      if(rectoFtpCheck?.data){
        const rectoFtpCheckBlob = b64toBlob(rectoFtpCheck.data, 'image/jpeg')
        setRectoImages([{...rectoFtpCheckBlob, preview: URL.createObjectURL(rectoFtpCheckBlob)}]);
      }
      else
        setRectoImages([])
    }
    else
      setRectoImages([])
    
    if(versoPath){
      const versoFtpCheck = await getFtpCheck(versoPath, versoIsAbsolutePath);
      if(versoFtpCheck?.data){
        const versoFtpCheckBlob = b64toBlob(versoFtpCheck.data, 'image/jpeg')
        setVersoImages([{...versoFtpCheckBlob, preview: URL.createObjectURL(versoFtpCheckBlob)}]);
      }
      else
        setVersoImages([])
    }
    else
      setVersoImages([])
    setDisableChoosePart(false);
  };

  const [rectoImages, setRectoImages] = useState<any[]>([]);
  const [versoImages, setVersoImages] = useState<any[]>([]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'image/*',
    multiple: false,
    maxSize: 30000000,
    onDrop: (acceptedFiles, rejectedFiles) => {
      setRectoImages(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      })));
      if(rejectedFiles?.length && rejectedFiles[0].errors){
        if(rejectedFiles[0].errors.find(e => e.code === "file-invalid-type"))
          alert.error("Veuillez sélectionner des fichiers du type Image")
        else if(rejectedFiles[0].errors.find(e => e.code === "file-too-large"))
          alert.error("La taille du fichier est supérieure à 30 Mo")
      }
    }
  });
  const { getRootProps: getRootProps2, getInputProps: getInputProps2, isDragActive: isDragActive2 } = useDropzone({
    accept: 'image/*',
    multiple: false,
    maxSize: 30000000,
    onDrop: (acceptedFiles, rejectedFiles) => {
      setVersoImages(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      })));
      if(rejectedFiles?.length && rejectedFiles[0].errors){
        if(rejectedFiles[0].errors.find(e => e.code === "file-invalid-type"))
          alert.error("Veuillez sélectionner des fichiers du type Image")
        else if(rejectedFiles[0].errors.find(e => e.code === "file-too-large"))
          alert.error("La taille du fichier est supérieure à 30 Mo")
      }
    }
  });

  const [rectoCrop, setRectoCrop] = useState<any>(null);//type: "image/jpeg" size
  const [versoCrop, setVersoCrop] = useState<any>(null);
  // const [rectoCropUrl, setRectoCropUrl] = useState<any>(null);
  // const [versoCropUrl, setVersoCropUrl] = useState<any>(null);
  const [cropModal, setCropModal] = useState(false);
  const [disableSubmitCrop, setDisableSubmitCrop] = useState(false);
  const [reEnableCrop, setReEnableCrop] = useState(false);
  // const [cropPreview, setCropPreview] = useState(false);
  const [imgToEdit, setImgToEdit] = useState<any>(null);
  const handleToggleCrop = () => setCropModal(!cropModal);
  const [upImg, setUpImg] = useState();
  const imgRef = useRef<any>(null);
  const previewCanvasRef = useRef<any>(null);
  const [crop, setCrop] = useState({ unit: '%', width: 100, aspect: modeReglementValue?.value === constants.MODE_REGL_CHEQUE && 175 / 80 });
  const [completedCrop, setCompletedCrop] = useState<any>(null);
  const [isRotating, setIsRotating] = useState(false);

  // const onSelectFile = (e) => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     const reader = new FileReader();
  //     reader.addEventListener('load', () => setUpImg(reader.result));
  //     reader.readAsDataURL(e.target.files[0]);
  //   }
  // };

  const cropModalClosedHandle = () => {
    setImgToEdit(null);
    if(reEnableCrop){
      setDisableSubmitCrop(false);
      setReEnableCrop(false);
    }
  };

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    if(!crop || !canvas || !image) return

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext('2d');
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = 'high';

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
  }, [completedCrop]);

  const alert = useAlert();

  const clearInputs = () => {
    // setMontantFlag(true);
    setQuotePartFlag(true);
    // setBankValue('');
    // setBvValue('');
    setTireparValue('');//
    // setRefencaissementValue('');
    setMontantValue(0);
    setQuotePartValue(0);
    // setModeReglementValue(modereglementOptions[0]);
    setNepasverserValue(false)
    // setTypeEcheanceValue(typeecheanceOptions[0]);
    setDateCValue('');
    setDateEValue('');
    setDateCCanBeChanged(true)
    setDateECanBeChanged(true)
    setSelectedTypeClient('');
    setObservationValue('');
    // setDateCCanBeChanged(true);
    // setDateECanBeChanged(true);
    setMontantCanBeChanged(true);
    setQuotePartCanBeChanged(true);
    setQuotePartColor('');
    setPartFrom(0);

    setRectoImages([]);
    setVersoImages([]);
    setRectoCrop(null);
    setVersoCrop(null);

    // setSelectedAssociation('');
  }

  useEffect(() => {
    clearBanqueVersements();
    if(project?.LIBELE)
      getBanqueVersements(project.id, project.LIBELE);
  }, [getBanqueVersements, project]);

  useEffect(() => {
    getBanks();
  }, [getBanks]);

  useEffect(() => {
    return () => {
      clearBanks();
      clearBanqueVersements();
    }
  }, []);

  const partClickHandle = e => {
    //x
  };

  const handleTireParChange = data => {
    setTireparValue(data ? data.__isNew__ ? {name: data.value, isNew: true} : data.value : '');
  }
  const handleModeReglementChange = data => {
    setModeReglementValue(data || '');
  }
  const changeNepasverserHandle = (e) => {
    setNepasverserValue(e.target.checked);
  };
  const handleTypeEcheanceChange = data => {
    setTypeEcheanceValue(data || '');
  }
  const handleTypeClientChange = data => {
    setSelectedTypeClient(data || '');
  }
  const handleBankChange = data => {
    setBankValue(data ? data.value : '');
  }
  const handleBvChange = data => {
    setBvValue(data ? data.value : '');
  }
  const handleAuprofitdeChange = data => {
    setAuprofitdeValue(data ? data.value : '');
  }
  // const quantiteChangeHandler = (e/*: ITarget*/) => {
  //   const re = /^[0-9\b]+$/;
  //   if(re.test(e.target.value.toString()) && +e.target.value >= 1)
  //     setQuantite(+e.target.value);
  //   else if(e.target.value == ""){
  //     setQuantite(0);
  //     e.target.select();
  //   }
  // };
  const montantChangeHandler = (e/*: ITarget*/) => {
    setMontantCanBeChanged(false);
    const doubleValue = e.target.value ? e.target.value.toString().replace(",", ".") : 0,
      splits = doubleValue.toString().split(".");//console.log("splits", splits, doubleValue)
    if(!isNaN(doubleValue) && +doubleValue > 0){
      const res = splits.length === 2 && splits[1] !== "" ? Number((+doubleValue).toFixed(2)) : doubleValue;
      setMontantValue(res);
      if(quotePartCanBeChanged)
        setQuotePartValue(res);
      else if(quotePartValue > Number(res) || (partFrom && quotePartValue > quotePartMaxValue))
        setQuotePartColor('red');
      else
        setQuotePartColor('');
    }
    else if(e.target.value === ""){
      setMontantValue(0);
      if(quotePartCanBeChanged)
        setQuotePartValue(0)
    }
  };
  const montantChangeHandler1 = (e) => {
    setMontantCanBeChanged(false);
  };
  const montantChangeHandler2 = (e) => {
    const doubleValue = e.value ? +e.value : 0;
    setMontantValue(doubleValue);
    if(quotePartCanBeChanged)
      setQuotePartValue(doubleValue);
    else if(quotePartValue > Number(doubleValue) || (partFrom && quotePartValue > quotePartMaxValue))
      setQuotePartColor('red');
    else
      setQuotePartColor('');
  };

  const quotepartChangeHandler = (e/*: ITarget*/) => {
    setQuotePartCanBeChanged(false);
    const doubleValue = e.target.value ? e.target.value.toString().replace(",", ".") : 0,
      splits = doubleValue.toString().split(".");
    if(!isNaN(doubleValue) && +doubleValue > 0){
      const res = splits.length === 2 && splits[1] !== "" ? Number((+doubleValue).toFixed(2)) : doubleValue;
      setQuotePartValue(res);
      if(montantCanBeChanged)
        setMontantValue(res);
      else if(Number(res) > montantValue || (partFrom && res > quotePartMaxValue))
        setQuotePartColor('red');
      else
        setQuotePartColor('');
    }
    else if(e.target.value === ""){
      setQuotePartValue(0);
      if(montantCanBeChanged)
        setMontantValue(0);
    }
  };
  const quotepartChangeHandler1 = (e) => {
    setQuotePartCanBeChanged(false);
  };
  const quotepartChangeHandler2 = (e) => {
    const doubleValue = e.value ? +e.value : 0;
    setQuotePartValue(doubleValue);
    if(montantCanBeChanged)
      setMontantValue(doubleValue);
    else if(Number(doubleValue) > montantValue || (partFrom && doubleValue > quotePartMaxValue))
      setQuotePartColor('red');
    else
      setQuotePartColor('');
  };

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };
  
  useEffect(() => {
    if(!quotePartFlag)
      setQuotePartFlag(true)
    else if(quotePartValue === 0 && quotePartRef?.current)
      quotePartRef.current.select()
  }, [quotePartValue]);

  useEffect(() => {
    if(!montantFlag)
      setMontantFlag(true)
    else if(montantValue === 0 && montantRef?.current)
      montantRef.current.select()
  }, [montantValue]);

  // const tireparChangeHandler = (e: ITarget) => setTireparValue(e.target.value);
  const refencaissementChangeHandler = (e: ITarget) => setRefencaissementValue(e.target.value);
  const refencaissementBlurHandler = () => {
    if(!refencaissementValue || partFrom)
      return
    checkEncaissementUniqueness(refencaissementValue).then(e => {
      if(!e || !e.data){
        alert.error("Réf. Règlement existante dans le système");
        return
      }
    })
  };
  // const montantChangeHandler = (e: ITarget) => setMontantValue(e.target.value);
  const dateCChangeHandler = (e, t) => {
    setDateCCanBeChanged(false);
    setDateCValue(e);
    if(dateECanBeChanged)
      setDateEValue(e);
  };
  const dateEChangeHandler = (e, t) => {
    setDateECanBeChanged(false);
    setDateEValue(e);
    // if(dateCCanBeChanged)
    //   setDateCValue(e);
  };
  // const quotepartChangeHandler = (e: ITarget) => setQuotePartValue(e.target.value);
  const observationChangeHandler = (e: ITarget) => setObservationValue(e.target.value);

  useEffect(() => {
    if(tireparValue !== '' && !tireparValue["isNew"] && !table_clients.find(e => e.id === tireparValue["id"]))
      setTireparValue('')
    if(auprofitdeValue !== '' && !auprofitdeValue["all"] && !table_clients.find(e => e.id === auprofitdeValue["id"]))
      setAuprofitdeValue('')
  }, [table_clients]);

  useEffect(() => {
    setBvValue('');
  }, [project]);

  useEffect(() => {
    if(modeReglementValue?.value === modereglementOptions[0].value){
      setBvValue('');
      setCrop({ ...crop, aspect: 175 / 80 });
    }
    else
      setCrop({ ...crop, aspect: false });
  }, [modeReglementValue]);

  const addLine = async () => {
    if(tireparValue === ''){
      alert.error("Veuillez saisir le champs \"Tiré par / Effectué par\"");
      return
    }
    if(!modeReglementValue?.value){
      alert.error("Veuillez sélectionner le mode de Règlement");
      return
    }
    if(!partFrom && encaissementlines.find(e => e.REF_REGLEMENT === refencaissementValue)){
      alert.error("Encaissement déjà saisi, veuillez vérifier la Réf. Règlement");
      return
    }
    if(refencaissementValue === ''){
      alert.error("Veuillez saisir la Réf. Règlement");
      return
    }
    if(bankValue === ''){
      alert.error("Veuillez sélectionner une banque");
      return
    }
    if(auprofitdeValue === ''){
      alert.error("Veuillez saisir le champs \"Au profit de\"");
      return
    }
    if(montantValue === 0){
      alert.error("Veuillez saisir un montant supérieur à 0");
      return
    }
    if(quotePartValue === 0){
      alert.error("Veuillez saisir une quote part supérieur à 0");
      return
    }
    if(Number(quotePartValue) > Number(montantValue)){
      alert.info("Quote part supérieure au montant");
      return
    }
    if(partFrom && Number(quotePartValue) > Number(quotePartMaxValue)){
      alert.info("Quote part supérieure au maximum autorisé");
      return
    }
    if(!partFrom && bvValue === '' && modeReglementValue.value !== modereglementOptions[0].value){
      alert.error("Veuillez sélectionner la banque versement");
      return
    }
    if(dateEValue === '' || dateCValue === ''){
      alert.error("Veuillez sélectionner une date valide");
      return
    }
    if(!selectedTypeClient?.value){
      alert.error("Veuillez sélectionner le type client");
      return
    }
    if(!partFrom && !rectoImages?.length){
      alert.error("Veuillez sélectionner la face Recto du chèque");
      return
    }
    // if(!versoImages?.length){
    //   alert.error("Veuillez sélectionner la face Verso du chèque");
    //   return
    // }
    // if(encaissementlines.find(e => e.DATE_REGLEMENT.getDate() === new Date(dateEValue).getDate() && e.DATE_REGLEMENT.getMonth() === new Date(dateEValue).getMonth() && e.DATE_REGLEMENT.getFullYear() === new Date(dateEValue).getFullYear())){
    //   alert.info("Info: Vous avez saisi des encaissements de la même date", {timeout: 8000});
    // }
    setIsAddingLine(true)
    if(!partFrom){
      const uniquenessRes = await checkEncaissementUniqueness(refencaissementValue);
      if(!uniquenessRes || !uniquenessRes.data){
        alert.error("Réf. Règlement existante dans le système");
        setIsAddingLine(false)
        return
      }
    }

    const encaissementLine : IEncaissementLine = {
      PROJET: project.LIBELE,
      IDPROJET: project.id,
      TIRE_PAR: tireparValue["isNew"] ? tireparValue["name"] : `${tireparValue["NOM"]} ${tireparValue["PRENOM"]}`,
      ID_TIRE: tireparValue["isNew"] ? -1 : tireparValue["id"],
      MODE_REGL: modeReglementValue.value,
      TYPE_ECHEANCE: typeEcheanceValue.value,
      REF_REGLEMENT: refencaissementValue,
      BANQUE: bankValue["name"],
      IDBANQUE: bankValue["id"],
      DATE_REGLEMENT: new Date(dateEValue),
      DATE_PORTEFEUILLE: new Date(dateCValue),
      MONTANT: montantValue,
      PART: quotePartValue,
      partFrom,
      BANQUE_VERSEMENT: bvValue ? bvValue["libelle"] : "",
      id_banque: bvValue ? bvValue["id"] : undefined,
      PROFIT_DE: auprofitdeValue["all"] ? "Tout le monde" : `${auprofitdeValue["NOM"]} ${auprofitdeValue["PRENOM"]}`,
      ID_PROFIT: auprofitdeValue["all"] ? -1 : auprofitdeValue["id"],
      // ID_ASS: consultationIsAssociation ? selectedAssociation.id : undefined,
      STATUT: /*nepasverserValue ? constants.STATUT_ENC_A_NE_PAS_VERSER_NR : */constants.STATUT_ENC_DEFAULT,
      OBSERVATION: observationValue,
      typeClient: selectedTypeClient.value,
      SAISIE_PAR: auth?.user && auth?.user.username ? auth?.user.username : undefined,
      ID_COM: auth?.user && auth?.user.id ? auth?.user.id : undefined,
      // recto: rectoCrop ? rectoCrop.preview : rectoImages[0].preview,
      // verso: versoImages?.length ? versoCrop ? versoCrop.preview : versoImages[0].preview : undefined,
      recto: rectoCrop || rectoImages[0],
      verso: versoImages?.length ? versoCrop || versoImages[0] : undefined,
      anpv: nepasverserValue ? 1 : 0,
      commentAnpv: commentAnpv,
      commentDateEnc: commentDateEnc,
      lineIndex: lineCountValue,
    };
    addEncaissementLine(encaissementLine);
    setLineCount(lineCountValue + 1);
    setAddedFlag(true);
    setTimeout(() => setAddedFlag(false), 2000);
    clearInputs();
    setIsAddingLine(false)
  };
  
  useEffect(() => () => {
    // Make sure to revoke the data uris to avoid memory leaks
    // rectoImages.forEach(file => URL.revokeObjectURL(file.preview));
  }, [rectoImages]);
  
  const okok = () => {
    var reader = new FileReader();
    reader.onload = function() {
      var arrayBuffer = this.result,
        codedBuffer: string = "";
      (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
          codedBuffer += String.fromCharCode(byte);
      });

      // axios.post('/api/banks/test', {codedBuffer, name: "1.jpg"})
      // axios.post('/api/banks/test', {codedBuffer: encode(arrayBuffer as ArrayBuffer), name: "1.jpg"})
      axios.post('/api/banks/test', {codedBuffer: codedBuffer, name: "1.jpg"})
      .then(res =>{
          console.log("res", res);
        }
      )
      .catch(err =>
        console.log("err asyncselect", err)
      );
    }
    reader.readAsArrayBuffer(rectoImages[0]);
  }
  
  const okok2 = () => {
    var reader = new FileReader();
    reader.onload = function() {
      var arrayBuffer = this.result,
        codedBuffer: string = "";
      (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
          codedBuffer += String.fromCharCode(byte);
      });

      // axios.post('/api/banks/test', {codedBuffer, name: "2.jpg"})
      // axios.post('/api/banks/test', {codedBuffer: encode(arrayBuffer as ArrayBuffer), name: "2.jpg"})
      axios.post('/api/banks/test', {codedBuffer: codedBuffer, name: "2.jpg"})
      .then(res =>{
          console.log("res", res);
        }
      )
      .catch(err =>
        console.log("err asyncselect", err)
      );
    }
    reader.readAsArrayBuffer(versoImages[0]);
  }

  const rotateImg = (imgUrl: string, degrees: number, setImg: Function) => {
    if(isRotating)
      return
    setIsRotating(true);
    const image = new Image();
    image.src = imgUrl;
    image.onload = function() {
      const canvas = document.createElement("canvas");
      const w = image.width;
      const h = image.height;
      const rads = degrees * Math.PI/180;
      let c = Math.cos(rads);
      let s = Math.sin(rads);
      if (s < 0) { s = -s; }
      if (c < 0) { c = -c; }
      //use translated width and height for new canvas
      canvas.width = h * s + w * c;
      canvas.height = h * c + w * s;
      //draw the rect in the center of the newly sized canvas
      const ctx = canvas.getContext("2d");
      if(ctx){
        ctx.translate(canvas.width/2, canvas.height/2);
        ctx.rotate(degrees * Math.PI / 180);
        ctx.drawImage(image, -image.width/2, -image.height/2);
        setImg(e => ({...e, img: canvas.toDataURL("image/jpeg")}));
        setIsRotating(false);
      }
    };
  }

  return (
    <div>
      <Container className="addEncaissementLineDiv" style={isAddingLine ? {pointerEvents: "none"} : {}}>
        <div className="divSpanAsLink">
          {!partFrom ? <span className="divSpanAsLinkContent" onClick={() => setModalPart(true)}><FontAwesomeIcon icon={faSearchDollar} />&nbsp;&nbsp;<span>Utiliser un encaissement existant</span></span>
          : <span className="divSpanAsLinkContent" style={{color: "orangered", ...(disableChoosePart ? {opacity: .6} : {})}} onClick={() => {
            if(!disableChoosePart){
              setPartFrom(0);
              clearInputs();
            }
          }}><FontAwesomeIcon icon={disableChoosePart ? faSpinner : faTimes} className={disableChoosePart ? "spinner" : ""} />&nbsp;&nbsp;<span>Utiliser un nouveau encaissement</span></span>}
        </div>
        <Row className="justify-content-around">
          <Col xs="12" sm="4">
            <FormGroup style={{position: "relative"}}>
              <Label for="modereglement">Mode de règlement</Label>
              <Select
                id="modereglement"
                name="modereglement"
                className="reactselect"
                classNamePrefix="react-select"
                defaultValue={modereglementOptions[0]}
                value={modeReglementValue}
                onChange={handleModeReglementChange}
                isClearable={false}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                options={modereglementOptions}
                isDisabled={!!partFrom}
              />
              {(modeReglementValue?.value === constants.MODE_REGL_CHEQUE && !partFrom) && <div className="inputBottomSwitch">
                <div onClick={() => setAnpvModal(true)}>
                  <CustomInput type="switch" id="nepasverser" name="nepasverserSwitch" label="À ne pas verser" className="switchDanger" checked={nepasverserValue} onChange={changeNepasverserHandle} />
                </div>
              </div>}
            </FormGroup>
          </Col>
          <Col xs="12" sm="4">
            <FormGroup>
              <Label for="typeecheance">Type échéance</Label>
              <Select
                id="typeecheance"
                name="typeecheance"
                className="reactselect"
                classNamePrefix="react-select"
                defaultValue={typeecheanceOptions[0]}
                value={typeEcheanceValue}
                onChange={handleTypeEcheanceChange}
                isClearable={false}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                options={typeecheanceOptions}                
              />
            </FormGroup>
          </Col>
          <Col xs="12" sm="4">
            <FormGroup>
              {/* <Label for="tirepar">Tiré par</Label>
              <Input id="tirepar" type="text" placeholder="Tiré par..." value={tireparValue} onChange={tireparChangeHandler} className="form-control" /> */}
              <Label for="tirepar">{modeReglementValue?.value === constants.MODE_REGL_CHEQUE ? "Tiré" : "Effectué"} par</Label>
              <CreatableSelect
                id="tirepar"
                className="reactselect"
                classNamePrefix="react-select"
                value={tireparValue ? {label: tireparValue["isNew"] ? tireparValue["name"] : `${tireparValue["NOM"]} ${tireparValue["PRENOM"]}`, value: tireparValue} : null}
                onChange={handleTireParChange}
                formatCreateLabel={(e, t) => `${e}`}
                placeholder={`${modeReglementValue?.value === constants.MODE_REGL_CHEQUE ? "Tiré" : "Effectué"} par...`}
                isClearable={true}
                // isLoading={loadingBank}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                options={(isConsultation ? (consulationClients || []) : table_clients).map(e => ({value: e, label: `${e.NOM} ${e.PRENOM}`}))}
                isDisabled={!!partFrom}
                menuContainerStyle={{ zIndex: 9999999 }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="justify-content-around">
          <Col xs="12" sm="4">
            <FormGroup>
              <Label for="refencaissement">Réf. Règlement</Label>
              <Input id="refencaissement" type="text" placeholder="Référence du règlement..." disabled={!!partFrom} value={refencaissementValue} onChange={refencaissementChangeHandler} onBlur={refencaissementBlurHandler} className="form-control" />
            </FormGroup>
          </Col>
          <Col xs="12" sm="4">
            <FormGroup>
              <Label for="bank">Banque</Label>
              <Select
                id="bank"
                name="bank"
                className="reactselect"
                classNamePrefix="react-select"
                value={bankValue ? {label: bankValue["fullname"], value: bankValue} : null}
                onChange={handleBankChange}
                placeholder={'Chercher par nom...'}
                isClearable={true}
                isLoading={loadingBank}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                labelKey='name'
                options={selectBankOptions}
                isDisabled={!!partFrom}
                menuContainerStyle={{ zIndex: 9999999 }}
              />
            </FormGroup>
          </Col>
          <Col xs="12" sm="4">
            <FormGroup>
              <Label for="auprofitde">Au profit de</Label>
              <Select
                id="auprofitde"
                name="auprofitde"
                className="reactselect"
                classNamePrefix="react-select"
                value={auprofitdeValue ? {label: auprofitdeValue["all"] ? "Tout le monde" : `${auprofitdeValue["NOM"]} ${auprofitdeValue["PRENOM"]}`, value: auprofitdeValue} : null}
                onChange={handleAuprofitdeChange}
                placeholder={'Chercher par nom...'}
                isClearable={true}
                // isLoading={loadingBank}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                // labelKey='name'
                options={[...((isConsultation ? (consulationClients || []) : table_clients).length > 1 ? [{value: {all: true}, label: "Tout le monde"}] : []), ...(isConsultation ? (consulationClients || []) : table_clients).map(e => ({value: e, label: `${e.NOM} ${e.PRENOM}`}))]}
                menuContainerStyle={{ zIndex: 9999999 }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="justify-content-around">
          <Col xs="12" sm="4">
            <FormGroup>
              <Label for="montant">Montant</Label>
              <InputGroup className="quantityInputGroup">
                {/* <Input id="montant" type="number" pattern="[0-9]*" placeholder="Montant..." innerRef={montantRef} disabled={!!partFrom} value={Number(montantValue).toString()} onFocus={montantFocusHandler} onChange={montantChangeHandler} className="form-control" /> */}
                <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="montant" pattern="[0-9]*" placeholder="Montant..." innerRef={montantRef} disabled={!!partFrom} value={montantValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onChange={montantChangeHandler1} onValueChange={montantChangeHandler2}/* onChange={montantChangeHandler}*/ className="form-control" />
                <InputGroupAddon addonType="append">
                  <InputGroupText>DH</InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </FormGroup>
          </Col>
          <Col xs="12" sm="4">
            <FormGroup>
              <Label for="quotepart">Quote part</Label>
              <InputGroup className="quantityInputGroup">
                {/* <Input id="quotepart" type="number" pattern="[0-9]*" placeholder="Quote part..." innerRef={quotePartRef} value={Number(quotePartValue).toString()} onFocus={quotePartFocusHandler} onChange={quotepartChangeHandler} className="form-control" style={quotePartColor ? {color: quotePartColor} : {}} /> */}
                <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="quotepart" pattern="[0-9]*" placeholder="Quote part..." innerRef={quotePartRef} value={quotePartValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onChange={quotepartChangeHandler1} onValueChange={quotepartChangeHandler2}/* onChange={quotepartChangeHandler}*/ className="form-control" style={quotePartColor ? {color: quotePartColor} : {}} />
                <InputGroupAddon addonType="append">
                  <InputGroupText>DH</InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </FormGroup>
          </Col>
          <Col xs="12" sm="4">
            <FormGroup>
              <Label for="bv">Banque versement</Label>
              <Select
                id="bv"
                name="bv"
                className="reactselect"
                classNamePrefix="react-select"
                isDisabled={!modeReglementValue?.value || modeReglementValue?.value === modereglementOptions[0].value || !!partFrom}
                value={bvValue ? {label: bvValue["num_compte"], value: bvValue} : null}
                onChange={handleBvChange}
                placeholder={'Chercher par nom...'}
                isClearable={true}
                isLoading={loadingBv}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                labelKey='libelle'
                options={selectBvOptions}
                menuContainerStyle={{ zIndex: 9999999 }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="justify-content-around">
          <Col xs="12" sm="4">
            <FormGroup>
              <Label for="cDatepicker">Date du {getEncModeRegl(modeReglementValue?.value, false) || "Chèque"}</Label>
              <DatePicker id="cDatepicker"
                value={dateCValue}
                dateFormat={constants.DP_DATE_FORMAT}
                dayLabels={constants.DP_DAYS}
                monthLabels={constants.DP_MONTHS}
                weekStartsOn={constants.DP_WEEK_START}
                onChange={(v,f) => dateCChangeHandler(v, f)}
                disabled={!!partFrom} />
            </FormGroup>
          </Col>
          <Col xs="12" sm="4" style={((!dateCValue && !dateCValue) || moment(dateCValue).isSame(dateEValue, "date")) ? {} : {border: "2px dashed blue", borderRadius: "8px"}}>
            <FormGroup>
              <Label for="eDatepicker" style={{display: "flex"}}>Date d'Encaissement (prolongation){!!(!partFrom && modeReglementValue?.value === constants.MODE_REGL_CHEQUE) && <>&nbsp;<div style={{cursor: "pointer", textDecoration: "underline", fontSize: "small", fontStyle: "italic"}} onClick={() => setDateEncModal(true)}>Modifier</div></>}</Label>
              <DatePicker id="eDatepicker"
                value={dateEValue}
                dateFormat={constants.DP_DATE_FORMAT}
                dayLabels={constants.DP_DAYS}
                monthLabels={constants.DP_MONTHS}
                weekStartsOn={constants.DP_WEEK_START}
                disabled />
            </FormGroup>
          </Col>
          <Col xs="12" sm="4">
            <FormGroup>
              <Label for="typeclient">Type Client</Label>
              <Select
                id="typeclient"
                name="typeclient"
                className="reactselect"
                classNamePrefix="react-select"
                value={selectedTypeClient}
                onChange={handleTypeClientChange}
                isClearable={false}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                options={typeClientOptions}
                isDisabled={!!partFrom}
              />
            </FormGroup>
          </Col>
          {/* <Col xs="12" sm="4">
            <FormGroup>
              <Label for="observation">Observation</Label>
              <Input id="observation" type="text" placeholder="Commentaire..." value={observationValue} onChange={observationChangeHandler} className="form-control" />
            </FormGroup>
          </Col> */}
        </Row>
        {showComment ? <Row className="fadeAnimation">
          <Col xs="12" sm="12">
            <FormGroup>
              <Label for="observation">Observation</Label>
              <Input id="observation" type="text" placeholder="Commentaire..." value={observationValue} onChange={observationChangeHandler} className="form-control" />
            </FormGroup>
          </Col>
        </Row> : <Row className="justify-content-end"><div style={{cursor: "pointer", fontSize: "small", fontWeight: 600}} onClick={() => setShowComment(true)}><FontAwesomeIcon icon={faCommentMedical} />&nbsp;Ajouter un commentaire</div></Row>}
        {!!partFrom ? null : <Row className="justify-content-around">
          <Col xs="12" sm="6">
            <FormGroup>
              <Label>Scan du chèque</Label>
              <section className="container">
                <div {...getRootProps({className: `dropzone${isDragActive ? " dropzoneHovered" : ""}`})}>
                  <input {...getInputProps()} />
                  {/* <p>Drag 'n' drop some files here, or click to select files</p> */}
                  {rectoImages?.length ? <aside className="thumbContainer">
                    <div className="thumbEdit" onClick={e => (e.stopPropagation(), setImgToEdit({img: rectoImages?.length ? rectoImages[0].preview : null, type: constants.RECTO}), setCropModal(true))} title="Modifier le scan"><FontAwesomeIcon icon={faPen} style={{fontSize: "small"}} /></div>
                    <div className="thumbDelete" onClick={e => (e.stopPropagation()/*, setRectoCropUrl(null)*/, setRectoCrop(null), setRectoImages([]))} title="Supprimer le scan"><FontAwesomeIcon icon={faTimes} style={{fontSize: "small"}} /></div>
                    <div className="thumb" key={rectoImages[0].name}>
                      <div className="thumbInner">
                        <img src={rectoCrop ? rectoCrop.preview : rectoImages[0].preview} className="thumbImg" />
                      </div>
                    </div>
                  </aside> : <span style={{margin: "20px"}}><FontAwesomeIcon icon={faFileImage} /> Choisir ou <FontAwesomeIcon icon={faHandRock} /> déposer la face <span style={{fontWeight: 600}}>Recto</span> ici</span>}
                </div>
              </section>
            </FormGroup>
          </Col>
          <Col xs="12" sm="6">
            <FormGroup>
              <Label style={{display: "block"}}>&nbsp;</Label>
              <section className="container">
                <div {...getRootProps2({className: `dropzone${isDragActive2 ? " dropzoneHovered" : ""}`})}>
                  <input {...getInputProps2()} />
                  {/* <p>Drag 'n' drop some files here, or click to select files</p> */}
                  {versoImages?.length ? <aside className="thumbContainer">
                    <div className="thumbEdit" onClick={e => (e.stopPropagation(), setImgToEdit({img: versoImages?.length ? versoImages[0].preview : null, type: constants.VERSO}), setCropModal(true))} title="Modifier le scan"><FontAwesomeIcon icon={faPen} style={{fontSize: "small"}} /></div>
                    <div className="thumbDelete" onClick={(e) => (e.stopPropagation()/*, setVersoCropUrl(null)*/, setVersoCrop(null), setVersoImages([]))} title="Supprimer le scan"><FontAwesomeIcon icon={faTimes} style={{fontSize: "small"}} /></div>
                    <div className="thumb" key={versoImages[0].name}>
                      <div className="thumbInner">
                        <img src={versoCrop ? versoCrop.preview : versoImages[0].preview} className="thumbImg" />
                      </div>
                    </div>
                  </aside> : <span style={{margin: "20px"}}><FontAwesomeIcon icon={faFileImage} /> Choisir ou <FontAwesomeIcon icon={faHandRock} /> déposer la face <span style={{fontWeight: 600}}>Verso</span> ici</span>}
                </div>
              </section>
            </FormGroup>
          </Col>
        </Row>}
        {/* {isConsultation && consultationIsAssociation ? <Row className="justify-content-center mb-2">
          <Col xs="12" sm="4">
            <div className={`encChooseAsso${selectedAssociation ? " encChooseAssoSelected" : ""}`} title={selectedAssociation ? `${selectedAssociation.POURCENTAGE || "-"}% | ${selectedAssociation.ETAGE === "0" ? "RDC" : `Étage ${selectedAssociation.ETAGE || "-"}`} | ${selectedAssociation.contrat_clients?.map(e => e.client).map(e => `${e.NOM} ${e.PRENOM}`).join(", ")}` : ""} onClick={() => setModalAss(true)}>
              {!selectedAssociation ? "Choisir une part de l'association" : `${selectedAssociation.POURCENTAGE || "-"}% | ${selectedAssociation.ETAGE === "0" ? "RDC" : `Étage ${selectedAssociation.ETAGE || "-"}`} | ${selectedAssociation.contrat_clients?.map(e => e.client).map(e => `${e.NOM} ${e.PRENOM}`).join(", ")}`}
            </div>
          </Col>
        </Row> : null} */}
        <Row className="justify-content-around">
          <Col xs="12" sm="4">
            <FormGroup className="text-center">
              <Button
                className="btn btn-success addEncaissementLineBtn btnB animatedIconsBtn"
                color="dark"
                // size="sm"
                disabled={disableChoosePart || isAddingLine}
                onClick={addLine}
                ><div className="animatedIconsGroup">
                  <FontAwesomeIcon icon={faArrowDown} className={`animatedIcon defaultIcon${addedFlag ? "Flag" : ""}`} />
                  <FontAwesomeIcon icon={faCheck} className={`animatedIcon hiddenIcon${addedFlag ? "Flag" : ""}`} />
                </div>Ajouter l'encaissement</Button>
            </FormGroup>
            {/* <FormGroup className="text-center">
              <Button
                className="btn btn-primary addEncaissementLineBtn"
                color="dark"
                // size="sm"
                onClick={addLine}
                ><FontAwesomeIcon icon={addedFlag ? faCheck : faArrowDown} />&nbsp;&nbsp;Ajouter</Button>
            </FormGroup> */}
          </Col>
        </Row>
      </Container>

      <Modal isOpen={cropModal} toggle={handleToggleCrop} onClosed={cropModalClosedHandle}>
        <ModalHeader toggle={handleToggleCrop}><FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp;{imgToEdit?.type && `Modification de la face ${imgToEdit.type === constants.RECTO ? "Recto" : imgToEdit.type === constants.VERSO ? "Verso" : ""}`}</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer">
            {/* {!cropPreview ?  */}
            <Row className="linesConfirmationRow justify-content-around">
              <Col xs="11" sm="6">
                <Button
                  className="btn btn-info linesConfirmationBtn fullEllipsis mt-0"
                  onClick={() => rotateImg(imgToEdit.img, -90, setImgToEdit)}><FontAwesomeIcon icon={faUndo} />
                  &nbsp;&nbsp;Faire pivoter vers la gauche
                </Button>
              </Col>
              <Col xs="11" sm="6">
                <Button
                  className="btn btn-info linesConfirmationBtn fullEllipsis mt-0"
                  onClick={() => rotateImg(imgToEdit.img, 90, setImgToEdit)}><FontAwesomeIcon icon={faRedo} />
                  &nbsp;&nbsp;Faire pivoter vers la droite
                </Button>
              </Col>
            </Row>
            <Row className="linesConfirmationRow justify-content-center">
              {imgToEdit?.img && <ReactCrop
                src={imgToEdit.img}
                // src={rectoImages[0].preview}
                // src={upImg}
                onImageLoaded={onLoad}
                crop={crop}
                onChange={(c) => setCrop(c)}
                onComplete={(c) => setCompletedCrop(c)}
              />}
            </Row>
            <Row className="linesConfirmationRow justify-content-center">
              {/* <div> */}
              <canvas
                ref={previewCanvasRef}
                // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
                style={{
                  width: Math.round(completedCrop?.width ?? 0),
                  height: Math.round(completedCrop?.height ?? 0)
                }}
              />
              {/* </div> */}
            </Row>
            {/* {!cropPreview ? <Row>
              <Button
                className="btn btn-warning linesConfirmationBtn linesDeleteBtn"
                onClick={() => setCropPreview(true)}
                ><FontAwesomeIcon icon={faSearch} />&nbsp;&nbsp;Vérifier</Button>
            </Row> : <Row>
              <Button
                className="btn btn-danger linesConfirmationBtn linesDeleteBtn"
                onClick={() => setCropPreview(false)}
                ><FontAwesomeIcon icon={faArrowLeft} />&nbsp;&nbsp;Modifier</Button>
              <Button
                className="btn btn-success linesConfirmationBtn linesDeleteBtn"
                onClick={() => setCropPreview(false)}
                ><FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp;Valider</Button>
            </Row>} */}
            <Row className="justify-content-center">
              <Col xs="10" md="3">
                <Button
                  className="btn btn-danger linesConfirmationBtn"
                  onClick={() => {
                    // setRectoCropUrl(null);
                    if(imgToEdit.type === constants.RECTO)
                      setRectoCrop(null)
                    else if(imgToEdit.type === constants.VERSO)
                      setVersoCrop(null)
                    setCropModal(false);
                  }}
                  ><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Initialiser</Button>
              </Col>
              <Col xs="10" md="6">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={() => {
                    if (!completedCrop || !previewCanvasRef || completedCrop.width === 0 || completedCrop.height === 0)
                      return
                    setDisableSubmitCrop(true);
                    
                    previewCanvasRef.current.toBlob(
                      (blob) => {
                        const previewUrl = window.URL.createObjectURL(blob);
                        blob.preview = previewUrl;
                        if(imgToEdit.type === constants.RECTO){
                          // setRectoCropUrl(previewUrl);
                          setRectoCrop(blob);
                        }
                        else if(imgToEdit.type === constants.VERSO){
                          // setVersoCropUrl(previewUrl);
                          setVersoCrop(blob);
                        }
                        setReEnableCrop(true);
                        setCropModal(false);
                  
                        // const anchor = document.createElement('a');
                        // anchor.download = 'cropPreview.png';
                        // anchor.href = URL.createObjectURL(blob);
                        // anchor.click();
                  
                        // window.URL.revokeObjectURL(previewUrl);
                      },
                      'image/jpeg',
                      1
                    );
                  }}
                  disabled={disableSubmitCrop}
                  ><FontAwesomeIcon icon={disableSubmitCrop ? faSpinner : faCheck} className={disableSubmitCrop ? "spinner" : ""} />&nbsp;&nbsp;Modifier</Button>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalPart} toggle={handleTogglePart} className="modal-dialog-large">
        <ModalHeader toggle={handleTogglePart}><FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp;Encaissements avec montant restant</ModalHeader>
        <ModalBody>
          <div>
              <div style={{height: "auto"}}>
                <div style={{textAlign: "center", marginBottom: "20px", fontSize: "large", fontWeight: 600}}>Veuillez sélectionner un encaissement de la liste<span style={{float: "right", cursor: "pointer"}} onClick={(e) => setPartSearchVisibility(!partSearchVisibility)} ><FontAwesomeIcon icon={faSearch} /></span></div>
                {partSearchVisibility && <Container className="searchBienDiv fadeAnimation">
                  <Row className="justify-content-around" style={{alignItems: "end"}}>
                    <Col xs="12" md="4">
                      <FormGroup>
                        <Label for="projet">Projet</Label>
                        <Input id="projet" placeholder="Projet..." value={projetSValue} onChange={projetSChangeHandler} />
                      </FormGroup>
                    </Col>
                    <Col xs="12" md="4">
                      <FormGroup>
                        <Label for="refReglement">Réf. réglement</Label>
                        <Input id="refReglement" placeholder="Référence du règlement..." value={refReglementSValue} onChange={refReglementSChangeHandler} />
                      </FormGroup>
                    </Col>
                    <Col xs="12" md="4">
                      <FormGroup>
                        <Label for="tireParS">Effectué/Tiré par</Label>
                        <Input id="tireParS" placeholder="Effectué/Tiré par..." value={tireParSValue} onChange={tireParSSChangeHandler} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="justify-content-around mb-3" style={{alignItems: "end"}}>
                    <Col xs="12" md="4">
                      <FormGroup>
                        <Label for="auprofitdeS">Au profit de</Label>
                        <Input id="auprofitdeS" placeholder="Au profit de..." value={auprofitdeSValue} onChange={auprofitdeSSChangeHandler} />
                      </FormGroup>
                    </Col>
                    <Col xs="12" md="4">
                      <FormGroup>
                        <Label for="banqueS">Banque</Label>
                        <Input id="banqueS" placeholder="Banque..." value={banqueSValue} onChange={banqueSChangeHandler} />
                      </FormGroup>
                    </Col>
                    <Col xs="12" md="4">
                      <FormGroup>
                        <Label for="modeReglementS">Mode de règlement</Label>
                        <Input id="modeReglementS" placeholder="Mode de règlement..." value={modeReglementSValue} onChange={modeReglementSChangeHandler} />
                      </FormGroup>
                    </Col>
                  </Row>
                </Container>}
                {loadingE ? <Loading size={90} /> : remainingEncaissements?.length ? remainingEncaissements.filter(e => {
                  return (e.PROJET?.toLowerCase().includes(projetSValue.toLowerCase()) || !projetSValue)
                      && (e.REF_REGLEMENT?.toLowerCase().includes(refReglementSValue.toLowerCase()) || !refReglementSValue)
                      && (e.TIRE_PAR?.toLowerCase().includes(tireParSValue.toLowerCase()) || !tireParSValue)
                      // && (e.PROFIT_DE?.toLowerCase().includes(auprofitdeSValue.toLowerCase()) || !auprofitdeSValue)
                      && ((e.contrat_encaissements && e.contrat_encaissements.filter(t => t.PROFIT_DE?.toLowerCase().includes(auprofitdeSValue.toLowerCase())).length > 0) || !auprofitdeSValue)
                      && (e.BANQUE?.toLowerCase().includes(banqueSValue.toLowerCase()) || !banqueSValue)
                      && (e.MODE_REGL?.toLowerCase().includes(modeReglementSValue.toLowerCase()) || !modeReglementSValue)
                }).map((e, key) =>(
                  <Container className="CardInfo" key={key}>
                    <Row>
                      <Col xs="12" md="2" className="encaissementPartImgCol">
                        <div className="encaissementPartImg"></div>
                        {e.recto_name || e.verso_name || e.URL || e.URL_VERSO ? <div className="encaissementPartScan" onClick={() => (setPartScanModalData(e), setPartScanModal(true))}><FontAwesomeIcon icon={faEye} />&nbsp;Aperçu</div> : null}
                      </Col>
                      <Col xs="12" md="10" style={{border: "none"}}>
                        <Row className="justify-content-between" style={{alignItems: "center"}}>
                          <h3 style={{textDecoration: "underline"}}>{getEncModeRegl(e.MODE_REGL)}</h3>
                          <h5 style={{fontFamily: "'Courier New'"}}>{ e.REF_REGLEMENT || "" }</h5>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6">
                            <FontAwesomeIcon icon={faCheck} />&nbsp;<strong>ID Système : </strong>{ e.id || "-" }
                          </Col>
                          <Col xs="12" sm="6">
                            <FontAwesomeIcon icon={faCheck} />&nbsp;<strong>Projet : </strong>{ e.PROJET || "-" }
                          </Col>
                          {/* <Col xs="12" sm="4">
                            <FontAwesomeIcon icon={faCheck} />&nbsp;<strong>Réf. règlement : </strong>{ e.REF_REGLEMENT || "" }
                          </Col> */}
                        </Row>
                        <Row>
                          <Col xs="12" sm="6">
                            <FontAwesomeIcon icon={faCheck} />&nbsp;<strong>Date de règlement : </strong>{ e.DATE_REGLEMENT ? moment(e.DATE_REGLEMENT).format('DD/MM/YYYY') : "-" }
                          </Col>
                          <Col xs="12" sm="6">
                            <FontAwesomeIcon icon={faCheck} />&nbsp;<strong>Date de porte-feuille : </strong>{ e.DATE_PORTEFEUILLE ? moment(e.DATE_PORTEFEUILLE).format('DD/MM/YYYY') : "-" }
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6">
                            <FontAwesomeIcon icon={faCheck} />&nbsp;<strong>{e.MODE_REGL === constants.MODE_REGL_CHEQUE ? "Tiré" : "Effectué"} par : </strong>{ e.TIRE_PAR || "-" }
                          </Col>
                          <Col xs="12" sm="6">
                            <FontAwesomeIcon icon={faCheck} />&nbsp;<strong>Banque : </strong>{ e.BANQUE || "-" }
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6">
                            <FontAwesomeIcon icon={faCheck} />&nbsp;<strong>Montant initial : </strong>{ (e.MONTANT ? e.MONTANT.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-") + " Dh" }
                          </Col>
                          <Col xs="12" sm="6">
                            <FontAwesomeIcon icon={faCheck} />&nbsp;<strong>Montant restant : </strong>
                            { (e.contrat_encaissements && e.MONTANT ? Number(e.MONTANT - e.contrat_encaissements.reduce((e, t) => {
                              return t.PART ? e + Number(t.PART) : e
                            }, 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-") + " Dh" }
                          </Col>
                        </Row>
                        <Row className="justify-content-center">
                          <Col xs="12" sm="6">
                            <Button
                              className="btn btn-info"
                              color="info"
                              style={{width: "100%", fontWeight: 600}}
                              onClick={() => selectEncaissementHandle(e)}><FontAwesomeIcon icon={faCheckCircle} />&nbsp;Choisir</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Container>
                )) : <div style={{textAlign: "center", background: "#eeeeee", borderRadius: "4px"}}><i>Pas d'encaissements avec montant restant.</i></div>}
              </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={anpvModal} toggle={e => setAnpvModal(!e)}>
        <ModalHeader toggle={e => setAnpvModal(!e)}><FontAwesomeIcon icon={faCalendarTimes} />&nbsp;&nbsp;Demande du non-versement du chèque</ModalHeader>
        <ModalBody>
          <Row>
            <Col xs="12" className="fullFlexCenter">
              <CustomInput type="switch" id="nepasverserReq" name="nepasverserReqSwitch" disabled={isAddingLine} label="À ne pas verser" className="switchDanger" checked={nepasverserValue} onChange={changeNepasverserHandle} />
            </Col>
          </Row>
          <Row>
            <Col xs="12" sm="12">
              <FormGroup>
                <Label for="commentAnpv">Commentaire</Label>
                <Input id="commentAnpv" type="text" disabled={!nepasverserValue} placeholder="Commentaire..." value={commentAnpv} onChange={e => setCommentAnpv(e.target.value)} className="form-control" />
              </FormGroup>
            </Col>
          </Row>
          <div className="linesConfirmationRow" style={{marginBottom: "12px", color: "red"}}>
            Une demande de validation du non-versement du chèque sera envoyée à la direction.
          </div>
          <Row className="justify-content-center">
            <Col xs="12" className="fullFlexCenter">
              <Button
                className="btn btn-danger"
                color="danger"
                // style={{width: "100%", fontWeight: 600}}
                onClick={() => setAnpvModal(false)}><FontAwesomeIcon icon={faCheckCircle} />&nbsp;Fermer</Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <Modal isOpen={dateEncModal} toggle={e => setDateEncModal(!e)}>
        <ModalHeader toggle={e => setDateEncModal(!e)}><FontAwesomeIcon icon={faHourglassHalf} />&nbsp;&nbsp;Demande prolongation du versement du chèque</ModalHeader>
        <ModalBody>
          <Row>
            <Col xs="12">
              <FormGroup>
                <Label for="cDatepickerReq">Date du {getEncModeRegl(modeReglementValue?.value, false) || "Chèque"}</Label>
                <DatePicker id="cDatepickerReq"
                  value={dateCValue}
                  dateFormat={constants.DP_DATE_FORMAT}
                  dayLabels={constants.DP_DAYS}
                  monthLabels={constants.DP_MONTHS}
                  weekStartsOn={constants.DP_WEEK_START}
                  disabled />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <FormGroup>
                <Label for="eDatepickerReq">Date d'Encaissement (prolongation)</Label>
                <DatePicker id="eDatepickerReq"
                  value={dateEValue}
                  dateFormat={constants.DP_DATE_FORMAT}
                  dayLabels={constants.DP_DAYS}
                  monthLabels={constants.DP_MONTHS}
                  weekStartsOn={constants.DP_WEEK_START}
                  onChange={(v,f) => dateEChangeHandler(v, f)}
                  disabled={!!partFrom} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs="12" sm="12">
              <FormGroup>
                <Label for="commentDateEnc">Commentaire</Label>
                <Input id="commentDateEnc" type="text" disabled={((!dateCValue && !dateCValue) || moment(dateCValue).isSame(dateEValue, "date"))} placeholder="Commentaire..." value={commentDateEnc} onChange={e => setCommentDateEnc(e.target.value)} className="form-control" />
              </FormGroup>
            </Col>
          </Row>
          <div className="linesConfirmationRow" style={{marginBottom: "12px", color: "red"}}>
            Une demande de validation de la prolongation du versement du chèque sera envoyée à la direction.
          </div>
          <Row className="justify-content-center">
            <Col xs="12" className="fullFlexCenter">
              <Button
                className="btn btn-danger"
                color="danger"
                // style={{width: "100%", fontWeight: 600}}
                onClick={() => setDateEncModal(false)}><FontAwesomeIcon icon={faCheckCircle} />&nbsp;Fermer</Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <EncaissementScanModal modal={partScanModal} setModal={setPartScanModal} modalEncaissement={partScanModalData} setModalEncaissement={setPartScanModalData} />
      {/* <Modal isOpen={partScanModal} toggle={handleTogglePartScan} onOpened={modalOpenedHandlePartScan} onClosed={modalClosedHandlePartScan} className="modal-dialog-large">
        <ModalHeader toggle={handleTogglePartScan}><FontAwesomeIcon icon={faMoneyCheck} />&nbsp;&nbsp;Aperçu des Scans{partScanModalData && partScanModalData["REF_REGLEMENT"] ? (" - " + partScanModalData["REF_REGLEMENT"]) : ""}</ModalHeader>
        <ModalBody>
          <Container className="scanPreviewContainer">
            {rectoImg || rectoLoading ? <Row>
              <Col xs="12">Recto</Col>
              <Col xs="12">{rectoLoading ? <Loading /> : <img className="scanPreview" src={rectoImg}/>}</Col>
            </Row> : null}
            {versoImg || versoLoading ? <Row>
              <Col xs="12">Verso</Col>
              <Col xs="12">{versoLoading ? <Loading /> : <img className="scanPreview" src={versoImg}/>}</Col>
            </Row> : null}
          </Container>
        </ModalBody>
      </Modal> */}
    </div>
  );
};

const mapStateToProps = (state: IVEncaissementLineReduxProps) => ({
  encaissementline: state.encaissementline,
  banqueversement: state.banqueversement,
  bank: state.bank,
  encaissement: state.encaissement,
  client: state.client,
});

export default connect(mapStateToProps, { addEncaissementLine, getBanks, getBanqueVersements, clearBanqueVersements, clearBanks })(VAddEncaissement);
